const styles = {
  button: {
    width: [170, 170, 170, 170, '100%', '100%'],
    minHeight: 42
  },
  buttonsWrapper: {
    width: ['100%', '100%', 418],
    flexDirection: ['column', 'column', 'column', 'column', 'row', 'row'],
    alignItems: 'center'
  }
}

export default styles
